import { PropsWithChildren, useRef } from 'react'

import { useCreation } from 'ahooks'

import { RemoteTableStoreRef } from '@eastcoal/common/components/RemoteTable/Store/interface'

import { MemberBankListStoreContext } from './contexts/StoreContext'
import { MemberBankListStoreProviderProps } from './interface'
import { createMemberBankListStore } from './store/createStore'

export const MemberBankListStoreProvider = ({
  member,
  memberType,
  children
}: PropsWithChildren<MemberBankListStoreProviderProps>) => {
  const tableRef = useRef<RemoteTableStoreRef>(null)

  const store = useCreation(
    () => createMemberBankListStore({ tableRef, member, memberType }),
    [tableRef, member]
  )

  return (
    <MemberBankListStoreContext value={store}>
      {children}
    </MemberBankListStoreContext>
  )
}
